import { render } from "./MarketDefenceRegistry.vue?vue&type=template&id=53065c37&scoped=true"
import script from "./MarketDefenceRegistry.vue?vue&type=script&lang=js"
export * from "./MarketDefenceRegistry.vue?vue&type=script&lang=js"

import "./MarketDefenceRegistry.vue?vue&type=style&index=0&id=53065c37&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53065c37"]])

export default __exports__